import React, { Component, Fragment } from "react";
import { FormattedMessage } from "react-intl";
import ReactToPrint from "react-to-print";

import ConsentText from "../../modules/general-info/consent-text";
class ConstentModal extends Component {
  render() {
    const { consentText } = this.props;
    return (
      <Fragment>
        <ReactToPrint
          trigger={() => (
            <button className="Button--squared">
              <FormattedMessage id="app.print" />
            </button>
          )}
          content={() => this.componentRef}
          bodyClass="print-adjustments"
        />
        <ConsentText ref={el => (this.componentRef = el)} text={consentText} />
      </Fragment>
    );
  }
}

export default ConstentModal;



// WEBPACK FOOTER //
// ./src/modules/modal/consent-modal.js